import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

const defaultData: IDataLayer = {
  event_name: 'share wishlist',
  event_category: 'account',
  event_action: 'wishlist',
  event_label: 'share'
};

function trackEmailWishlist(_: string, eventData: IDataLayer = {}) {
  tealium.evtLink({ ...defaultData, ...eventData });
}

registerAnalyticsEventHandler('emailWishlist', trackEmailWishlist);
